import { FC } from "react";
import styles from './LinkItem.module.less';

const EntranceItem: FC = (props) => {
    const jump = (url) => {
        window.location.href = url;
    }
    return (
        <div onClick={() => jump(props.url)} className={styles.body}>
            <img style={{height: '100%', width: '100%', position: 'absolute'}} src={props.backImage} alt="" />
            <div className={styles.text}>{props.text}</div>
            <div className={styles.text2}>{props.text}</div>
        </div>
    );
}

export default EntranceItem;